import { Component, OnInit, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AinStateComponent } from '../../shared/design-system/state.component';
import { CatalogService, WorkOrder } from './catalog.service';

@Component({
  standalone: true,
  selector: 'ain-cmms-work-orders',
  imports: [RouterLink, AinPageComponent, AinStateComponent, TableModule, ButtonModule],
  template: `
    <ain-page [title]="t('catalog.cmms.workOrders.title')" [description]="t('catalog.cmms.workOrders.description')">
      @if (loading()) {
        <ain-state type="loading" [title]="t('catalog.loading')" />
      } @else {
        <section class="panel">
          <div class="toolbar">
            <button pButton type="button" [label]="t('catalog.action.create')" (click)="openCreate()"></button>
            <button pButton type="button" [label]="t('catalog.action.refresh')" severity="secondary" (click)="load()"></button>
            <a class="link" routerLink="/cmms/downtime">{{ t('catalog.cmms.downtime.dashboard') }}</a>
          </div>
          <p-table [value]="rows()" [paginator]="true" [rows]="15">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem"><input type="checkbox" aria-label="select all" /></th>
                <th>{{ t('catalog.cmms.workOrderNumber') }}</th>
                <th>{{ t('catalog.service.title') }}</th>
                <th>{{ t('catalog.tracking.status') }}</th>
                <th>{{ t('catalog.cmms.workOrderType') }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td><input type="checkbox" [attr.aria-label]="row.workOrderNumber" /></td>
                <td><button type="button" class="link-btn" (click)="openDetail(row.id)">{{ row.workOrderNumber }}</button></td>
                <td>{{ row.title }}</td>
                <td>{{ row.status }}</td>
                <td>{{ row.workOrderType }}</td>
              </tr>
            </ng-template>
          </p-table>
        </section>
      }
    </ain-page>
  `,
  styles: [`
    .panel { display: grid; gap: 10px; }
    .toolbar { display: flex; gap: 8px; align-items: center; }
    .link-btn { border: 0; background: none; color: #1d4ed8; cursor: pointer; font-weight: 600; padding: 0; }
    .link { color: #1d4ed8; font-weight: 600; text-decoration: none; margin-inline-start: auto; }
  `]
})
export class CmmsWorkOrdersComponent implements OnInit {
  private readonly service = inject(CatalogService);
  private readonly router = inject(Router);
  private readonly localization = inject(LocalizationService);

  readonly loading = signal(true);
  readonly rows = signal<WorkOrder[]>([]);

  ngOnInit(): void { this.load(); }

  load(): void {
    this.loading.set(true);
    this.service.listWorkOrders().subscribe({
      next: rows => { this.rows.set(rows); this.loading.set(false); },
      error: () => { this.rows.set([]); this.loading.set(false); }
    });
  }

  openDetail(id: string): void { void this.router.navigate(['/cmms/work-orders', id]); }
  openCreate(): void { void this.router.navigate(['/cmms/work-orders', 'new']); }

  t(key: string): string { return this.localization.translate(key); }
}
